import { useContext, useEffect } from "react";
import { AppContext } from "../context/AppContext";
import { MlWmsLayer, useMapState, useMap } from "@mapcomponents/react-maplibre";
import services from "../assets/services.json";
import * as turf from "@turf/turf";
import { DataContext } from "../context/DataContext";

export default function BackgroundServices() {
  const appContext = useContext(AppContext);
  const dataContext = useContext(DataContext);
  const mapState = useMapState({
    mapId: "map_1",
    watch: {
      viewport: true,
      layers: false,
    },
  });
  const mapHook = useMap({ mapId: "map_1" });

  useEffect(() => {
    if (!mapHook.map) {
      return;
    }
    if (mapState.viewport) {
      const bounds = mapHook.map?.getBounds();
      const canvasBound = bounds && [
        bounds.getWest(),
        bounds.getSouth(),
        bounds.getEast(),
        bounds.getNorth(),
      ];

      services &&
        services.forEach((service) => {
          const layer = mapHook.map?.getLayer(`wms-${service.land}`);
          if (layer) {
            // Convert service.bbox and canvasBound to Turf.js bounding box polygons
            const serviceBboxPolygon = turf.bboxPolygon(service.bbox);
            const canvasBoundPolygon = turf.bboxPolygon(canvasBound);

            // Check if the service bbox intersects with the canvas bounds
            const isIntersecting = turf.booleanIntersects(
              serviceBboxPolygon,
              canvasBoundPolygon
            );

            if (isIntersecting) {
              mapHook.map?.setLayoutProperty(
                `wms-${service.land}`,
                "visibility",
                "visible"
              );
            } else {
              mapHook.map?.setLayoutProperty(
                `wms-${service.land}`,
                "visibility",
                "none"
              );
            }
          }
        });
    }
  }, [mapState.viewport, mapHook.map]);
  useEffect(() => {
    if(!mapHook.map) {
      return;
    }
    if (dataContext.showHDWms) {
      mapHook.map?.zoomIn(0.01);
    } else {
      mapHook.map?.zoomOut(0.01);
    }
  }, [dataContext.showHDWms, mapHook.map]);

  return (
    <>
      {appContext.markerLayersReady && (
        <>
          <MlWmsLayer
            layerId="sentinel2"
            url="https://sgx.geodatenzentrum.de/wms_sentinel2_de"
            insertBeforeLayer="marker-wms"
            urlParameters={{ layers: "rgb" }}
            attribution="© Europäische Union, enthält Copernicus Sentinel-2 Daten 2021, verarbeitet durch das Bundesamt für Kartographie und Geodäsie (BKG)"
          />

          {dataContext.showHDWms &&
            services.map((service) => {
              const thuringenActive = mapHook.map?.map.getLayer("wms-Thüringen")
                ? true
                : false;

              return (
                <MlWmsLayer
                  key={service.land}
                  layerId={`wms-${service.land}`}
                  url={service.url}
                  insertBeforeLayer={
                    thuringenActive ? "wms-Thüringen" : "marker-wms"
                  }
                  urlParameters={service.url_parameters}
                  layerOptions={{ minzoom: 14 }}
                  attribution={service.attribution}
                />
              );
            })}
        </>
      )}
    </>
  );
}
